import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledFoodWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  font-family: ${props => props.theme.fonts.medium};
  max-width: ${rem('345px')};
  ${props => {
    switch (props.type) {
      case 'Disponibles':
        return css`
          background-color: ${props => props.theme.colors.colorFive};
        `;
      default:
        return css`
          background-color: ${props => props.theme.colors.grayLightest};
        `;
    }
  }};
  ${mediaqueries.greaterThan('desktop')`
      max-width: ${rem('386px')};
  `};
`;

const StyledFoodDetails = styled.div`
  color: ${props => props.theme.colors.dark};
  display: flex;
  flex-flow: column;
  justify-content: center;
  min-height: ${rem('108px')};
  padding: 2% 1% 0 1%;
  text-align: center;
  width: 100%;

  ${mediaqueries.greaterThan('mobile')`
      flex-flow: row;
      align-items: center;
      width: ${rem('266px')};
      padding-top: 0;
  `};
  ${mediaqueries.greaterThan('tablet')`
      width: ${rem('400px')};
  `};
`;

const StyledFoodType = styled.div`
  align-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.grayDarkest}0d;
  color: ${props => props.theme.colors.dark};
  display: flex;
  justify-content: center;
  min-height: ${rem('108px')};
  width: ${rem('52px')};
`;

const StyledFoodTypeLabel = styled.h2`
  font-size: ${rem('12px')};
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  transform: rotate(-90deg);
`;

const StyleFoodNumber = styled.span`
  font-size: ${rem('44px')};
  font-family: ${props => props.theme.fonts.bold};
  ${props => (props.type === 'Consumidos' ? `opacity: 0.5` : `opacity: 1`)};
`;

const StyleFoodSubtitle = styled.p`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.medium};
  line-height: 1;
  padding-top: ${rem('15px')};
  ${props => (props.type === 'Consumidos' ? `opacity: 0.5` : `opacity: 1`)};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('20px')};
    margin-left: ${rem('10px')} ;
    text-align: left;
    white-space: nowrap;
  `};
`;

export {
  StyledFoodWrapper,
  StyledFoodDetails,
  StyledFoodType,
  StyledFoodTypeLabel,
  StyleFoodNumber,
  StyleFoodSubtitle
};
